// Sikkerhetsnett så en uventet respons aldri gir en evig løkke
const MAX_PAGES = 1000;

// Henter alle sider fra et paginert Strapi-endepunkt.
// fetchPage(page) skal returnere { data: [...], pagination: { pageCount, total } }.
// Vi stoler på pageCount/total fra serveren, ikke på pageSize vi ba om, siden
// Strapi kan kappe pageSize til sin egen maxLimit. Feil på en senere side
// kastes videre – vi returnerer aldri en ufullstendig liste som om den var hel.
export async function fetchAllPages(fetchPage) {
    const byId = new Map();
    let page = 1;
    let pageCount = 1;
    let total = null;

    while (true) {
        const { data, pagination } = await fetchPage(page);

        if (!Array.isArray(data) || typeof pagination?.pageCount !== 'number') {
            throw new Error('Uventet svar fra serveren ved henting av side ' + page);
        }

        data.forEach((item) => byId.set(String(item.id), item));
        pageCount = pagination.pageCount;
        total = typeof pagination.total === 'number' ? pagination.total : null;

        if (page >= pageCount || data.length === 0) break;
        page += 1;
        if (page > MAX_PAGES) {
            throw new Error('For mange sider ved henting av data');
        }
    }

    if (total !== null && byId.size < total) {
        throw new Error(`Ufullstendig liste: fikk ${byId.size} av ${total}`);
    }

    return [...byId.values()];
}
